/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconScythe: {
  name: 'scythe';
  data: string;
} = {
  name: 'scythe',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M581.785 152.98C518.312-7.326 307.25 18.162 108.288 69.617v.002c-4.148 40.735 2.656 82.376 16.765 124.623C216.555 90.771 470.541 53.56 581.785 152.98z"/><path d="M78.472 73.43v.007L33.366 84.879c6.744 93.274 34.103 158.255 72.233 208.552-19.769 12.363-48.645 23.497-82.202 32.062 6.771 7.885 17.007 19.323 36.466 22.133 29.692-5.176 47.7-17.905 64.239-31.78C215.231 417.643 351.5 458.04 426.698 583.875l59.066-.156C347.812 329.085 96.825 436.05 78.472 73.43z"/></svg>`,
};
